import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../functions/ProfileContext';
import { getJwtToken } from '../auth';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { profile, loadingProfile } = useProfile();
    const location = useLocation();
    const token = getJwtToken();

    if (loadingProfile) {
        // Return an empty div with white background that fills the screen
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: '#ffffff',
                zIndex: 9999
            }}></div>
        );
    }

    if (!token || !profile?.naam) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;